



































































































import Component from "vue-class-component";
import {
  ConfiguredImageDto,
  DetailedImageRequirementDto,
  ImageFilterDto,
  ImageRequirementDto,
  ProductDto,
  ProductMediumDto,
  ProductTypeDto
} from "@swagger";
import ImagePreview from "@/components/ImagePreview.vue";
import BasicComponent from "@/global/BasicComponent";
import SelectableImagePreview from "@/components/SelectableImagePreview.vue";
import ImageBatchSelector from "@/components/product-configuration/ImageBatchSelector.vue";
import {ImageRows} from "@/global/types";
import ProductConfigurator from "@/components/product-configuration/ProductConfigurator.vue";

@Component({
  components: {ProductConfigurator, ImageSelectionRow: ImageBatchSelector, SelectableImagePreview, ImagePreview}
})
export default class ProductDetails extends BasicComponent {

  showAlert: number = 0;
  error: string|null = null;
  continueShopping: boolean = false;
  configuring: boolean = false;
  
  created() {

  }

  mounted() {
  }

  startConfiguration() {
    this.configuring = true;
  }

  /**
   * Called when an article has been added to the basket
   */
  addedToBasket(): void {
    this.error = undefined;
    this.showAlert++;
    const data = this;
    setTimeout(function () {
      data.showAlert--
    }, 5000)
    this.continueShopping = true;
  }

  onConfigurationError(error: string): void {
    this.error = error;
  }

  get price() {
    return this.product.price; //+ (this.isDetailedConfiguration ? this.product.detailedConfigurationSurcharge : 0);
  }

  get product(): ProductDto {
    const product = this.$store.getters.product(this.$route.params.id);

    if (product) {
      this.trackPage("P: " + product.name);
    }
    return product ? product : {
      imageRequirements: [],
      detailedImageRequirements: []
    };
  }

  get discount() {
    let instead = this.product.setPriceInsteadOf;
    if (!instead) instead = this.product.price;
    return this.product.price / instead - 1;
  }

  get hasDiscount() {
    return this.discount <= -0.01; // At least 1%
  }

  get hasImages() {
    return this.product.imageRequirements && this.product.imageRequirements.length > 0;
  }

  formatDiscount(discount) {
    return `${Math.round(discount * 100)}%`
  }

}
